@if (breakpointChanges | async; as breakpointState) {
  <button tdWbIconButton
          tdWbIconButtonShape="circle"
          tdWbIconButtonSize="small"
          [tdWbIconButtonBackground]="(breakpointState.matches && autoSizeOverride ? 'clear' : tdWbIconButtonBackground)"
          [tdWbHelpLink]="articleId"
          class="td-wb-toolbar-item-button"
          #helpLink="tdWbHelpLink"
          (click)="onClick()"
          [attr.data-td-wb-help-context-id]="helpLink.getArticleId()"
          [attr.title]="'tdWb.component.toolbar.HELP' | tdWbTranslate"
          [attr.aria-label]="'tdWb.component.toolbar.HELP' | tdWbTranslate">
    <td-wb-icon size="18"
                iconId="tooltip--small" />
    <ng-content />
  </button>
}
